import { useTutorAvailability } from '@api/schedule/tutor-availability.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware( () => {
  void useTutorAvailability()
})
